<!-- https://8es9hr.axshare.com/#g=1&p=%E5%8F%B0%E5%B9%A3%E5%AE%9A%E5%AD%98%E5%96%AE%E7%AE%A1%E7%90%86 -->
<!-- 台幣定存單管理 -->
<template>
  <div v-if="$route.meta.listKeepAlive">
    <workbench
      api="coopNtDepositOrder"
      :columns="columns"
      :toolbar="toolbar"
      :filter="filter"
      @editData="editData"
      @addData="editData"
      @enumData="getEnumData"
      ref="list"
    >
      <template slot="button">
        <div class="filter-group">
          <span class="filter-label ml10">定存單狀態</span>
          <el-select
            class="el-select"
            v-model="coopNtDepositStatusSelect"
            placeholder="請選擇"
          >
            <el-option value label="全部"></el-option>
            <el-option
              :value="data.value"
              :label="data.label"
              v-for="data of coopNtDepositStatus"
              :key="data.value"
            ></el-option>
          </el-select>

          <el-button
            type="primary"
            class="ml10"
            plain
            @click="openExportDepositOrderModal()"
            >列印定存單</el-button
          >
        </div>
      </template>
    </workbench>

    <el-dialog
      title="列印台幣定存單備查簿"
      :visible.sync="dialogOrder"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <el-form label-position="top">
        <el-form-item>
          <el-radio-group v-model="currentEdit.printType">
            <el-radio class="flex" :label="0">存單起（續）存日期</el-radio>
            <el-radio class="flex" :label="1">存單解約兌領日期</el-radio>
            <el-radio class="flex" :label="2">存單到期日期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <div class="date">
            <input
              type="text"
              class="min_go_date startDate1 startDate"
              placeholder="選擇日期"
            />
            <span class="el-input__prefix">
              <i class="el-icon-date"></i>
            </span>
          </div>
          ~
          <div class="date">
            <input
              type="text"
              class="min_go_date endDate1 endDate"
              placeholder="選擇日期"
            />
            <span class="el-input__prefix">
              <i class="el-icon-date"></i>
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="currentEdit.isEnd"
            :true-label="1"
            :false-label="0"
            >已解約兌領之存單要印出</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportDepositOrder">匯出</el-button>
        <el-button @click="dialogOrder = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
  <router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";

export default {
  name: "deposit_order",
  components: { Workbench },
  data() {
    return {
      dialogOrder: false,
      currentEdit: {
        printType: 0,
        isEnd: 0,
        dateStart: "",
        dateEnd: "",
      },
      coopNtDepositStatusSelect: "",
      toolbar: {},
      filter: {},
      coopNtDepositStatus: [],
      columns: [
        {
          label: "銀行名稱-開戶全銜",
          prop: "coopBankId",
          renderFunction(h, scope, enumData) {
            let coopBankName = "";
            enumData.bank.forEach((item) => {
              if (scope.row.coopBankId == item.id) {
                coopBankName = `${item.bankName}-${item.accountName}`;
              }
            });
            // let coop = enumData.bank.filter(coop => {
            //     return coop.id === scope.row.coopBankId;
            // });
            // if (coop[0]) {
            //     coopBankName = coop[0].accountName;
            // }
            return h("div", coopBankName ? coopBankName : "");
          },
        },
        {
          label: "存單帳號",
          prop: "accountNumber",
        },
        {
          label: "存單號碼",
          prop: "orderId",
        },
        {
          label: "存單金額",
          prop: "amount",
          addcomma: true,
        },
        {
          label: "存單計息方式",
          prop: "interestCalcFiexd",
          renderFunction(h, scope, enumData) {
            return h(
              "div",
              enumData.interestMethod[scope.row.interestCalcFiexd]
            );
          },
        },
        {
          label: "存單年利率",
          prop: "annualInterestRate",
        },
        {
          label: "起存日期",
          prop: "startDate",
          renderFunction(h, scope) {
            return h(
              "div",
              scope.row.startDate ? scope.row.startDate.split(" ")[0] : ""
            );
          },
        },
        {
          label: "到期日期",
          prop: "endDate",
          renderFunction(h, scope) {
            return h(
              "div",
              scope.row.endDate ? scope.row.endDate.split(" ")[0] : ""
            );
          },
        },
        {
          label: "存款月數",
          prop: "depositMonth",
        },
        {
          label: "印鑑名稱",
          prop: "sealName",
        },
        {
          label: "保管人姓名",
          prop: "custodian",
        },
        {
          prop: "updateTime",
          label: "最後修改",
        },
        {
          prop: "updateUserName",
          label: "最後修改人員",
        },
      ],
    };
  },
  watch: {
    coopNtDepositStatusSelect: function () {
      if (this.coopNtDepositStatusSelect !== "") {
        this.$set(
          this.filter,
          "filtercoopNtDepositStatus",
          this.coopNtDepositStatusSelect
        );
      } else {
        this.$delete(this.filter, "filtercoopNtDepositStatus");
      }
    },
  },
  methods: {
    openExportDepositOrderModal() {
      this.dialogOrder = true;
      setTimeout(() => {
        $(".min_go_date").datepicker({
          changeYear: true,
          changeMonth: true,
          currentText: "今天",
          dateFormat: "Rmmdd",
          showButtonPanel: true,
          yearRange: "1912:c+10",
          onSelect: (date) => {},
        });
      }, 200);
    },
    exportDepositOrder() {
      let dateStartVal = $(".startDate").val();
      let dateEndVal = $(".endDate").val();

      if (dateStartVal === "") {
        this.$message({
          type: "error",
          message: "請選擇起始日期",
        });
        return;
      } else if (dateEndVal === "") {
        this.$message({
          type: "error",
          message: "請選擇結束日期",
        });
        return;
      }

      let paramData = {
        action: "printPdf",
        type: this.currentEdit.printType,
        dateStart: this.toFormalDate(dateStartVal),
        dateEnd: this.toFormalDate(dateEndVal),
        isEnd: this.currentEdit.isEnd,
      };
      let urlParam = this.bindObjectParam(paramData);
      let fullUrl = `${API.coopNtDepositOrder}?${urlParam}`;
      this.mDownloadFile(fullUrl);
      this.dialogOrder = false;
    },
    toFormalDate(date) {
      let dateArray = date.split("-");
      console.log(dateArray);
      return `${parseInt(dateArray[0]) + 1911}/${dateArray[1]}/${dateArray[2]}`;
    },
    bindObjectParam(obj) {
      return Object.keys(obj)
        .map((item) => `${item}=${obj[item]}`)
        .join("&");
    },
    editData(id) {
      this.$router.push({
        name: "deposit_order_edit",
        params: { id: id },
      });
    },
    getEnumData(data) {
      this.coopNtDepositStatus = Object.keys(data.coopNtDepositStatus).map(
        (key) => {
          return {
            label: data.coopNtDepositStatus[key],
            value: parseInt(key),
          };
        }
      );
    },
  },
};
</script>